import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgLegume(props) {
    return (
        <Svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M11.457 15.953a4.22 4.22 0 00-7.237 2.824 3.374 3.374 0 104.765 4.308 4.222 4.222 0 001.884-.735 3.373 3.373 0 004.688-2.795 3.375 3.375 0 00-4.1-3.602z"
                fill={baseColors.green.dark}
            />
            <Path
                d="M9.972 23.676a.844.844 0 01-.787-.537l-1.533-3.93a.843.843 0 111.572-.614l1.534 3.93a.843.843 0 01-.786 1.15z"
                fill={baseColors.green.pastel}
            />
            <Path
                d="M11.544 23.062a.86.86 0 01-.394-.097.844.844 0 01-.447-.824c.132-1.4.711-2.722 1.652-3.767a.844.844 0 111.252 1.132 4.847 4.847 0 00-1.223 2.79.844.844 0 01-.84.766zM8.4 24.29a.841.841 0 01-.567-.218 4.846 4.846 0 00-2.79-1.224.843.843 0 11.155-1.68c1.4.131 2.721.71 3.767 1.651a.844.844 0 01-.566 1.47z"
                fill={baseColors.green.pastel}
            />
            <Path
                d="M19.864 38.897l-6.288 2.454-6.06-12.148a4.623 4.623 0 118.578-3.348l3.77 13.042z"
                fill={baseColors.orange.primary}
            />
            <Path d="M28.688 2.531h3.375v23.625h-3.376V2.531z" fill={baseColors.green.dark} />
            <Path
                d="M30.281 19.61a7.279 7.279 0 00-.398-1.483l-3.727-9.69-2.531.844 3.614 9.397c.4 1.04.605 2.143.605 3.256v2.995l2.437-5.318z"
                fill={baseColors.green.dark}
            />
            <Path
                d="M33.994 34.356a3.208 3.208 0 010 3.85l-.012.016a3.587 3.587 0 01-2.869 1.434h-1.476a3.586 3.586 0 01-2.869-1.434l-.012-.016a3.209 3.209 0 010-3.85l1.088-1.45V24.93l2.437-5.318.094-.205 4.219-10.968 2.531.843-3.614 9.397a9.063 9.063 0 00-.605 3.256v10.972l1.088 1.45z"
                fill={baseColors.green.dark}
            />
            <Path
                d="M33.994 38.206l-.012.016a3.573 3.573 0 01-1.358 1.1l-5.045-.315a3.553 3.553 0 01-.811-.785l-.012-.016a3.208 3.208 0 010-3.85l.075-.1 1.013-.506 5.062-11.816v10.972l1.088 1.45a3.209 3.209 0 010 3.85z"
                fill="#027E2A"
            />
            <Path
                d="M8.496 31.498a.844.844 0 01-.307-1.63l1.572-.614a.845.845 0 01.613 1.572l-1.571.614a.847.847 0 01-.307.058zM13.212 29.657a.844.844 0 01-.307-1.63l1.572-.613a.844.844 0 11.613 1.572l-1.571.613a.845.845 0 01-.307.058zM9.852 34.565a.844.844 0 01-.307-1.63l2.229-.844a.843.843 0 11.613 1.572l-2.229.844a.845.845 0 01-.306.058zM15.225 32.495a.844.844 0 01-.307-1.63l.786-.307a.844.844 0 01.613 1.572l-.786.307a.844.844 0 01-.306.058z"
                fill="#E78244"
            />
            <Path
                d="M19.934 21.094h2.002a3.586 3.586 0 013.208 1.983l.696 1.392h-2.003a3.587 3.587 0 01-3.207-1.983l-.696-1.392z"
                fill={baseColors.green.pastel}
            />
            <Path
                d="M24.008 29.32a.844.844 0 01-.844-.843 6.006 6.006 0 014.815-5.874l.082-.016a.843.843 0 11.331 1.654l-.082.017a4.314 4.314 0 00-3.458 4.219.844.844 0 01-.844.843z"
                fill={baseColors.black}
            />
            <Path
                d="M33.994 38.206l-.012.016a3.573 3.573 0 01-1.358 1.1l-5.045-.315a3.553 3.553 0 01-.811-.785l-.012-.016a3.208 3.208 0 010-3.85l.075-.1 1.013-.506 5.062-11.816v10.972l1.088 1.45a3.209 3.209 0 010 3.85z"
                fill="#E6F4F4"
            />
            <Path
                d="M20.987 26.79a2.492 2.492 0 012.073 1.109 1.14 1.14 0 001.896 0 2.493 2.493 0 014.019-.175l.198.248a5.484 5.484 0 01.368 6.333l-1.646 2.634a1.742 1.742 0 01-2.71.308 1.665 1.665 0 00-2.354 0 1.742 1.742 0 01-2.71-.308l-1.646-2.634a5.484 5.484 0 01.368-6.333l.198-.248a2.493 2.493 0 011.946-.935z"
                fill="#E82F3E"
            />
            <Path
                d="M21.579 33.75a.84.84 0 01-.597-.247 2.496 2.496 0 01-.468-2.885l.31-.62a.844.844 0 011.51.754l-.311.62a.81.81 0 00.152.937.844.844 0 01-.596 1.441z"
                fill="#FF6268"
            />
            <Path d="M2.531 41.344H51.47v5.062H2.53v-5.062z" fill="#EA9D2D" />
            <Path
                d="M7.594 44.719H5.906a.844.844 0 110-1.688h1.688a.844.844 0 110 1.688zM48.094 44.719h-1.688a.844.844 0 010-1.688h1.688a.844.844 0 010 1.688z"
                fill="#C38325"
            />
            <Path d="M2.531 46.406H51.47v5.063H2.53v-5.063z" fill="#FBB540" />
            <Path
                d="M7.594 49.781H5.906a.843.843 0 110-1.687h1.688a.843.843 0 110 1.687zM27.844 44.719h-1.688a.844.844 0 010-1.688h1.688a.844.844 0 010 1.688zM27.844 49.781h-1.688a.844.844 0 110-1.687h1.688a.844.844 0 110 1.687zM48.094 49.781h-1.688a.844.844 0 110-1.687h1.688a.844.844 0 110 1.687z"
                fill="#C38325"
            />
            <Path
                d="M37.125 31.219l.741.741a6.11 6.11 0 011.79 4.321h2.532v-.843a6.111 6.111 0 00-1.79-4.322l-.742-.741-2.531.844z"
                fill={baseColors.green.dark}
            />
            <Path
                d="M47.25 31.219l-.741.741a6.11 6.11 0 00-1.79 4.321h-2.532v-.843a6.111 6.111 0 011.79-4.322l.742-.741 2.531.844z"
                fill={baseColors.green.dark}
            />
            <Path
                d="M51.469 24.68a3.158 3.158 0 00-1.14-2.433 3.164 3.164 0 00-2.868-3.888 6.325 6.325 0 00-10.968 0 3.163 3.163 0 00-2.867 3.888 3.163 3.163 0 00-.425 4.437 4.218 4.218 0 006.302 5.333 5.244 5.244 0 002.474-1.01 5.247 5.247 0 002.473 1.01 4.219 4.219 0 006.302-5.333 3.149 3.149 0 00.717-2.004z"
                fill={baseColors.green.dark}
            />
            <Path
                d="M44.364 21.094a.844.844 0 01-.796-.563 1.689 1.689 0 00-3.183 0 .844.844 0 11-1.591-.563 3.377 3.377 0 016.365 0 .844.844 0 01-.795 1.126zM37.758 27a2.532 2.532 0 010-5.063.844.844 0 110 1.688.844.844 0 100 1.688.844.844 0 110 1.687z"
                fill={baseColors.green.pastel}
            />
            <Path d="M2.531 36.281H51.47v5.063H2.53V36.28z" fill="#FBB540" />
            <Path
                d="M7.594 39.656H5.906a.843.843 0 110-1.687h1.688a.843.843 0 110 1.687zM48.094 39.656h-1.688a.844.844 0 110-1.687h1.688a.844.844 0 110 1.687zM27.844 39.656h-1.688a.844.844 0 110-1.687h1.688a.844.844 0 110 1.687z"
                fill="#C38325"
            />
        </Svg>
    )
}

export default SvgLegume
